import { Button } from 'components/Button';
import { Heading, Paragraph } from 'components/Typography';
import config from 'config';
import { useTranslation } from 'react-i18next';

const supportEmail = config.get('supportEmail');
const signupManualConsultationPhoneNumber = config.get('signupManualConsultationPhoneNumber');

export const BoundaryErrorStep: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t(`signup.direct.steps.leadCreationFailed.title`)}
      </Heading>
      <Paragraph>
        {t(`screener.results.scheduleButton.errorMessage`, {
          supportEmail,
        })}
      </Paragraph>
      <Button data-testid="contact-us-button" as="a" href={`tel:${signupManualConsultationPhoneNumber}`} size="lg" className="sm-d:w-full">
        {t(`support.callUs`)}
      </Button>
    </>
  );
};
